export default {
  List: {
    ActionColumn: 'Chức năng',
    TitleMaster: 'Tài khoản ngầm định',
  },
};
